module.exports = __webpack_public_path__ + "static/media/logo-aws.45b19137.png";